import { reportLoadingScreen } from 'analytics/reporters';
import { isLoadingScreenVisible } from 'ducks/layout';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import Loading, { LoadingBall } from '@ingka/loading';
import '@ingka/loading/dist/style.css';

const LoadingScreenContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3000;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
`;

const LoadingScreen = () => {
  const visible = useSelector(isLoadingScreenVisible);

  useEffect(() => {
    visible && reportLoadingScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  if (!visible) {
    return null;
  }

  return (
    <LoadingScreenContainer data-testid="loading-spinner">
      <Loading text="">
        <LoadingBall />
      </Loading>
    </LoadingScreenContainer>
  );
};

export default LoadingScreen;
